import axios, { AxiosResponse } from "axios";
import { axiosInstance } from "src/services/axiosSetup";
import * as API from "src/services/consts/Campagin";

export function userEngagmentActionApiRequest(query: any): Promise<AxiosResponse> {
    query = query ? `?${query}` : "";
    return axiosInstance.get(`${API.URL_USER_ENGAGEMENT_ACTIONS}${query}`).then((d: AxiosResponse) => d.data);
}

